import React, { Component } from 'react';
import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';
import logo from '../../img/logo2.png';
import globalizacao from '../escolha/globalizacao';
//location.pathname
//location.pathname
var path = window.location.pathname.indexOf("/site2/build/") >= 0 ? "/site2/build/" : "/"


class Menu extends Component {

    esconderMenu() {

    }

    posicionar() {
        window.scrollTo(0, 0);
        this.props.onClickItem();
    }


    render() {

        return (
            <div className="limite">

                <nav className="clearfix" >
                    <img className="logo-img" src={logo} />

                    <ul className="lista-menu">
                        <li>
                            <Link
                                onClick={this.props.onClickItem}
                                className=""
                                to={path + "?s=home-header"}>
                                <i className="material-icons">home</i>
                                <span className="">
                                    {globalizacao.msg("inicio")}
                                </span>

                            </Link>
                        </li>

                        <li>
                            <Link
                                onClick={this.props.onClickItem}
                                className=""
                                to={path + "?s=nossos-apps"}>
                                <i className="material-icons">smartphone</i>
                                <span className="">
                                    Apps
                                 </span>

                            </Link>
                        </li>
                        <li>
                            <Link
                                onClick={this.props.onClickItem}
                                className=""
                                to={path + "?s=team"}>
                                <i className="material-icons">group_work</i>
                                <span className="">
                                    {globalizacao.msg("nossaEquipe")}
                                </span>

                            </Link>
                        </li>
                        <li>
                            <Link
                                onClick={this.props.onClickItem}
                                className=""
                                to={path + "?s=awards"}>
                                <i className="material-icons">stars</i>
                                <span className="">
                                    {globalizacao.msg("awards")}
                                </span>

                            </Link>
                        </li>

                        <li>
                            <Link
                                onClick={this.props.onClickItem}
                                className=""
                                to={path + "?s=sobre"}>
                                <i className="material-icons">info</i>
                                <span className="">
                                    {globalizacao.msg("about")}
                                </span>

                            </Link>
                        </li>

                        <li>
                            <Link
                                onClick={this.props.onClickItem}
                                className=""
                                to={path + "?s=contato"}>
                                <i className="material-icons">mail</i>
                                <span className="">
                                    {globalizacao.msg("contato")}
                                </span>

                            </Link>
                        </li>

                    </ul>

                </nav>
            </div>
        );
    }
}


export default Menu;



// WEBPACK FOOTER //
// ./src/js/components/menu.js